import { RangeMode } from './range-display';

export interface RangeModeOption {
  id: RangeMode;
  labelKey: string;
}

const ALL_RANGE_MODES: RangeModeOption[] = [
  { id: 'equal', labelKey: 'LanguageService::EqualTo' },
  { id: 'range', labelKey: 'LanguageService::Between' },
  { id: 'periods', labelKey: 'LanguageService::Periods' },
];

export function getRangeModeOptions(includePeriods: boolean): RangeModeOption[] {
  return includePeriods
    ? ALL_RANGE_MODES
    : ALL_RANGE_MODES.filter(mode => mode.id !== 'periods');
}
